
import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import moment from "moment";
import VPagination from "@hennge/vue3-pagination";

export default {
    components: { customModal, VPagination },

    props: {
        studyId: {
            type: String,
            default: ""
        },
        toFilter: { type: String, default: "" }
    },

    data() {
        return {
            baseapi: process.env.VUE_APP_Service_URL,
            loading: false,

            summary: {
                enrolledSubject: 0,
                withdrawnPatients: 0,
                totalCohorts: 0
            },

            patients: [],
            defaultdate: "",
            currentPage: 1,
            pageSize: 10,
            totalPages: 0
        };
    },

    watch: {
        studyId: {
            async handler() {
                this.currentPage = 1;
                await this.fetchSubjectSummary(1);
            }
        },
        toFilter: {
            async handler() {
                this.currentPage = 1;
                await this.fetchSubjectSummary(1);
            }
        }
    },

    mounted() {
        this.defaultdate = localStorage.getItem("dateformat");
        this.fetchSubjectSummary();
    },

    methods: {
        async fetchSubjectSummary(page = this.currentPage) {
            this.loading = true;

            const url =
                `${this.baseapi}/management/patient/getsubjectsafetysummary` +
                `?studyId=${this.studyId}` +
                `&toFilter=${this.toFilter}` +
                `&PageNumber=${page}` +
                `&PageSize=${this.pageSize}`;

            const token = store.getters.getIdToken;

            try {
                const res = await axios.get(url, {
                    headers: { Authorization: "Bearer " + token }
                });

                this.summary = {
                    enrolledSubject: res.data.enrolledSubject || 0,
                    withdrawnPatients: res.data.withdrawnPatients || 0,
                    totalCohorts: res.data.totalCohorts || 0
                };

                this.patients = res.data.patients || [];

                this.currentPage = page;
                this.totalPages = Math.ceil((res.data.totalCount || 0) / this.pageSize);

            } catch (err) {
                console.error("Error fetching subject summary:", err);
                this.patients = [];
                this.totalPages = 0;
            } finally {
                this.loading = false;
            }
        },

        formatDate(date) {
            if (!date) return "-";
            return moment(date).format(this.defaultdate || "YYYY-MM-DD");
        },
        loadPage(page) {
            this.fetchSubjectSummary(page);
        }
    }
};
